
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/institutional",
      function () {
        return require("private-next-pages/institutional/index.page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/institutional"])
      });
    }
  